import script from "./Steps.vue?vue&type=script&setup=true&lang=js"
export * from "./Steps.vue?vue&type=script&setup=true&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=04bd79ed&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04bd79ed"]])

export default __exports__